import { Component, OnInit } from '@angular/core';
// import { $ } from 'protractor';

@Component({
  selector: 'app-sidebar-nav',
  templateUrl: './sidebar-nav.component.html',
  styleUrls: ['./sidebar-nav.component.scss']
})
export class SidebarNavComponent implements OnInit {
	hideSideNav: boolean = false;

  constructor() { 
  }

  ngOnInit() {
  }
  shouldRun = [/(^|\.)plnkr\.co$/, /(^|\.)stackblitz\.io$/].some(h => h.test(window.location.host));


  //toggleSidebarNav() {}

  toggleSidebarNav(): void {
    this.hideSideNav = !this.hideSideNav;

    const mainsection = document.getElementById('contentsection');
    mainsection.style.marginLeft = this.hideSideNav ? `${50}px` : `${186}px`;
  }
}
